import getInitialTaskQuota from "./getInitialTaskQuota";

const tasksMutations = {
    SET_TASK(state, task) {
        state.task = task;
    },

    CLEAR_TASK(state) {
        state.task = {};
    },

    SET_QUESTION_IDS(state, payload) {
        state.questionIds = payload;
    },

    SET_CORE_QUESTIONS(state, payload) {
        state.groups[payload.index].core_questions = payload.questions;
    },

    // ADD_QUESTION(state, payload) {
    //   state.questions.push(payload)
    // },

    ADD_QUESTION_MEDIA(state, payload) {
        payload.media.forEach((file) => {
            state.groups[payload.gIndex].core_questions[payload.qIndex].media.push(file);
        });
    },

    REMOVE_QUESTION_MEDIA(state, payload) {
        state.groups[payload.gIndex].core_questions[payload.qIndex].media.splice(payload.mediaIndex, 1);
    },

    ADD_CORE_QUESTION(state, payload) {
        let index = _.findIndex(state.groups, {id: payload.id});
        state.groups[index].core_questions.push(payload.question);
    },

    SET_ADDITIONAL_QUESTIONS(state, payload) {
        state.groups[payload.index].additional_questions = payload.questions;
    },

    ADD_ADDITIONAL_QUESTION(state, payload) {
        let index = _.findIndex(state.groups, {id: payload.id});
        state.groups[index].additional_questions.push(payload.question);
    },

    UPDATE_QUESTION(state, payload) {
        if(payload.question.additional_question) {
            let index = _.findIndex(state.groups[payload.groupIndex].additional_questions, {id: payload.question.id});
            state.groups[payload.groupIndex].additional_questions.splice(index, 1, payload.question);
        } else {
            let index = _.findIndex(state.groups[payload.groupIndex].core_questions, {id: payload.question.id});
            state.groups[payload.groupIndex].core_questions.splice(index, 1, payload.question);
        }
    },

    DELETE_QUESTION(state, payload) {
        if(payload.question.additional_question) {
            let index = _.findIndex(state.groups[payload.groupIndex].additional_questions, {id: payload.question.id});
            state.groups[payload.groupIndex].additional_questions.splice(index, 1);
        } else {
            let index = _.findIndex(state.groups[payload.groupIndex].core_questions, {id: payload.question.id});
            state.groups[payload.groupIndex].core_questions.splice(index, 1);
        }
    },

    SET_TASK_GROUPS(state, payload) {
        state.groups = payload;
    },

    ADD_TASK_GROUP(state, payload) {
        state.groups.push(payload);
    },

    TASK_USER_COUNT_INCREMENT(state) {
        state.task.counts.participants++;
    },

    TASK_USER_COUNT_DECREMENT(state) {
        state.task.counts.participants--;
    },

    SET_TASK_REMINDERS(state, reminders) {
        state.reminders = reminders;
    },

    // SET_PROFILE_GROUPS(state, profileGroups) {
    //   state.task.profileGroups = profileGroups
    // },

    ADD_PROFILE_GROUP(state, group) {
        state.task.profileGroups.push(group);
    },

    // UPDATE_PROFILE_GROUP(state, group) {
    //   let index = _.findIndex(state.task.profileGroups, function(o) { return o.id == group.id; });
    //   state.task.profileGroups.splice(index, 1, group)
    // },
    //
    // DELETE_PROFILE_GROUP(state, profileGroupId) {
    //   let index = _.findIndex(state.task.profileGroups, function(o) { return o.id == profileGroupId; });
    //   state.task.profileGroups.splice(index, 1)
    // },

    UPDATE_PROFILE_GROUP_USER_COUNT(state, payload) {
        if(payload.to) {
            let index = _.findIndex(state.task.profileGroups, function(o) { return o.id == payload.to; });
            state.task.profileGroups[index].user_count++;
        }

        if(payload.from) {
            let index = _.findIndex(state.task.profileGroups, function(o) { return o.id == payload.from; });
            state.task.profileGroups[index].user_count--;
        }
    },

    UPDATE_HIDE_OTHER_ANSWERS(state, status) {
        state.task.hide_others_answers_until_first = status;
    },

    UPDATE_GROUP(state, payload) {
        let index = _.findIndex(state.groups, function(o) { return o.id == payload.id; });
        state.groups.splice(index, 1, payload);
        // const groupIndex = state.groups.findIndex(group => group.id === payload.group_id);
        // const questionIndex = state.groups[groupIndex].core_questions.findIndex(core => core.id === payload.id);
        // state.groups[groupIndex].core_questions.splice(questionIndex, 1, payload);
    },
    ADD_QUESTION_TO_GROUP(state, {newQuestion, index}) {
        const groupIndex = state.groups.findIndex(group => group.id === parseInt(newQuestion.group_id));
        state.groups[groupIndex].core_questions.splice(index, 0, newQuestion);
    },

    DELETE_TASK_GROUP(state, groupIndex) {
        state.groups.splice(groupIndex, 1);
    },

    SET_LANGUAGE(state, language) {
        state.task.language = language;
    },

    SET_TASK_CURRENT_GROUP(state, group) {
        state.currentGroup = group;
    },

    ADD_DATA_PARAM(state, param) {
        state.task.url_data_params.push(param);
    },

    UPDATE_DATA_PARAM(state, param) {
        let index = _.findIndex(state.task.url_data_params, function(o) { return o.id == param.id; });
        state.task.url_data_params.splice(index, 1, param);
    },

    DELETE_DATA_PARAM(state, index) {
        state.task.url_data_params.splice(index, 1);
    },

    SET_TRANSCRIPTION_LANGUAGE(state, language) {
        state.task.transcription_language = language;
    },

    SET_UPVOTE(state, payload) {
        state.task.upvote = payload;
    },

    UPDATE_QUOTA_FIELD(state, payload){
        state.task.quota = {
            ...state.task.quota,
            [payload.field]: payload.value
        };
    },

    UPDATE_QUOTA_SETTINGS(state, payload){
        state.task.quota = {
            ...state.task.quota,
            ...payload
        };
    },

    UPDATE_QUOTA_GROUP(state, payload){
        const index = state.task.quota.groups.findIndex(group =>
            group.id === payload.id);
        state.task.quota.groups[index].name = payload.name;
    },

    UPDATE_QUOTA_GROUP_ORDER(state, payload){
        state.task.quota.groups = payload;
    },

    ADD_QUOTA_GROUP(state, payload){
        state.task.quota.groups.push(payload);
    },

    DELETE_QUOTA_GROUP(state, id){
        state.task.quota.groups = state.task.quota.groups.filter(group => group.id !== id);
    },

    ADD_QUOTA(state, data){
        const {quotaGroupId, ...payload} = data;
        const index = state.task.quota.groups.findIndex(group =>
            group.id === quotaGroupId);
        state.task.quota.groups[index].rows.push(payload);
    },

    UPDATE_QUOTA(state, data){
        const {quotaGroupId, quotaRowId, ...payload} = data;
        const groupIndex = state.task.quota.groups.findIndex(group => group.id === quotaGroupId);
        const rowIndex = state.task.quota.groups[groupIndex].rows.findIndex(row => row.id === quotaRowId);
        state.task.quota.groups[groupIndex].rows[rowIndex].name = payload.name;
        state.task.quota.groups[groupIndex].rows[rowIndex].min = payload.min;
        state.task.quota.groups[groupIndex].rows[rowIndex].type = payload.type;
        state.task.quota.groups[groupIndex].rows[rowIndex].rows = payload.rows;
        state.task.quota.groups[groupIndex].rows[rowIndex].is_natural_fallout = payload.is_natural_fallout;
    },

    DELETE_QUOTA(state, {quotaGroupId, quotaRowId}){

        const index = state.task.quota.groups.findIndex(group =>
            group.id === quotaGroupId);

        state.task.quota.groups[index].rows =
            state.task.quota.groups[index].rows.filter(row => row.id !== quotaRowId);
    },

    UPDATE_QUOTA_MIN(state, {quotaGroupId, quotaRowId, value}){
        const groupIndex = state.task.quota.groups.findIndex(group => group.id === quotaGroupId);
        const rowIndex = state.task.quota.groups[groupIndex].rows.findIndex(row => row.id === quotaRowId);
        state.task.quota.groups[groupIndex].rows[rowIndex].min = value;
    },

    UPDATE_QUOTA_ROW_FIELD(state, {quotaGroupId, quotaRowId, value, fieldName}){
        const groupIndex = state.task.quota.groups.findIndex(group => group.id === quotaGroupId);
        const rowIndex = state.task.quota.groups[groupIndex].rows.findIndex(row => row.id === quotaRowId);
        state.task.quota.groups[groupIndex].rows[rowIndex][fieldName] = value;
    },

    UPDATE_QUOTA_GROUP_FIELD(state, {quotaGroupId, value, fieldName}){
        const groupIndex = state.task.quota.groups.findIndex(group => group.id === quotaGroupId);
        state.task.quota.groups[groupIndex][fieldName] = value;
    },

    SET_QUOTA_PROFILE_GROUPS(state, payload) {
        state.quotaProfileGroups = payload;
    },

    DELETE_ALL_QUOTAS(state) {
        state.task.quota = getInitialTaskQuota();
    },

    SET_QUOTAS(state, data) {
        state.task.quota = data;
    },

    SET_USER_INFO(state, payload) {
        state.userInfo = payload;
    },

};

export default tasksMutations;
